import React from 'react';

const SkeletonLoader = () => {
  return (
    <div className="t-w-full t-max-w-[520px] t-mx-auto t-px-[18px] sm:t-px-6 t-pt-10 t-pb-[180px] sm:t-pb-[160px]">
      <div className="t-space-y-4">
        <div className="t-h-6 t-w-2/3 t-rounded-md t-bg-g200 t-animate-pulse" />
        <div className="t-h-4 t-w-1/3 t-rounded-full t-bg-g200 t-animate-pulse" />
        <div className="t-mt-4 t-space-y-3">
          <div className="t-h-[52px] t-rounded-xl t-bg-g200 t-animate-pulse" />
          <div className="t-h-[52px] t-rounded-xl t-bg-g200 t-animate-pulse" />
          <div className="t-h-[52px] t-rounded-xl t-bg-g200 t-animate-pulse" />
          <div className="t-h-[52px] t-rounded-xl t-bg-g200 t-animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonLoader;
